/* Serviceability "by delivery mode" config — drives the per-mode left-nav and the
   mode-scoped Delivery Coverage view (route .../serviceability/:mode).
   Each LEAF is a single canonical service-type code (see supply-side serviceTypes.js),
   so the existing single-`serviceType` intel API filters it exactly — KPIs, charts and
   table all scope correctly, no backend change. Modes group by delivery mode first,
   then Regular/Large sub-variant. `hidden` modes are defined but not shown yet. */
export const SERV_MODES = [
  {key: 'sdd-reg', label: 'SDD — Regular', direction: 'FORWARD', serviceTypes: ['SDD_FWD_REG']},
  {key: 'sdd-large', label: 'SDD — Large', direction: 'FORWARD', serviceTypes: ['SDD_FWD_LARGE']},
  {key: 'sc-ndd-reg', label: 'Same City NDD — Regular', direction: 'FORWARD', serviceTypes: ['SC-NDD_FWD_REG']},
  {key: 'sc-ndd-large', label: 'Same City NDD — Large', direction: 'FORWARD', serviceTypes: ['SC-NDD_FWD_LARGE']},
  {key: 'ic-ndd-reg', label: 'Inter City NDD — Regular', direction: 'FORWARD', serviceTypes: ['Intercity_NDD_REG']},
  {key: 'ic-ndd-large', label: 'Inter City NDD — Large', direction: 'FORWARD', serviceTypes: ['Intercity_NDD_LARGE']},
  {key: 'surface-reg', label: 'Surface Forward — Regular', direction: 'FORWARD', serviceTypes: ['FWD_SURFACE_REG']},
  {key: 'surface-large', label: 'Surface Forward — Large', direction: 'FORWARD', serviceTypes: ['FWD_SURFACE_LARGE']},
  {key: 'air-reg', label: 'Forward Air — Regular', direction: 'FORWARD', serviceTypes: ['FWD_AIR_REG']},
  {key: 'air-large', label: 'Forward Air — Large', direction: 'FORWARD', serviceTypes: ['FWD_AIR_LARGE']},
  {key: 'rvp-qc-reg', label: 'RVP with QC — Regular', direction: 'REVERSE', serviceTypes: ['REV_REG_QC']},
  {key: 'rvp-qc-large', label: 'RVP with QC — Large', direction: 'REVERSE', serviceTypes: ['REV_LARGE_QC']},
  {key: 'rvp-noqc-reg', label: 'RVP without QC — Regular', direction: 'REVERSE', serviceTypes: ['REV_REG_NOQC']},
  {key: 'rvp-noqc-large', label: 'RVP without QC — Large', direction: 'REVERSE', serviceTypes: ['REV_LARGE_NOQC']},
  /* hidden until courier-partner coverage exists */
  {key: 'hv-fwd-reg', label: 'High Value Forward — Regular', hidden: true, direction: 'FORWARD', serviceTypes: ['HV_FWD_REG']},
  {key: 'hv-fwd-large', label: 'High Value Forward — Large', hidden: true, direction: 'FORWARD', serviceTypes: ['HV_FWD_LARGE']},
  {key: 'hv-rev-reg', label: 'High Value Reverse — Regular', hidden: true, direction: 'REVERSE', serviceTypes: ['HV_REVERSE_REG']},
  {key: 'hv-rev-large', label: 'High Value Reverse — Large', hidden: true, direction: 'REVERSE', serviceTypes: ['HV_REVERSE_LARGE']},
  {key: 'sub4h', label: 'Sub-4 hour', hidden: true, direction: 'FORWARD', serviceTypes: ['SUB4H']},
  {key: 'h2to4', label: '2–4 hour', hidden: true, direction: 'FORWARD', serviceTypes: ['H2TO4']},
  {key: 'sub2h', label: 'Sub-2 hour', hidden: true, direction: 'FORWARD', serviceTypes: ['SUB2H']},
]

export const SERV_MODE_BY_KEY = Object.fromEntries(SERV_MODES.map((m) => [m.key, m]))

/* Resolve a mode's service-type codes to the backend's actual casing.
   The codes above are only a best-effort hint; the source of truth is the
   /form-options service-type list. We match case/format-insensitively and
   return the backend's exact string, so the API can never miss on a casing
   drift (e.g. INTERCITY_NDD_REG vs Intercity_NDD_REG). Unresolved codes fall
   back to the hint and warn in dev so the mismatch is visible, not silent. */
const normCode = (s) => String(s || '').toLowerCase().replace(/[\s_-]/g, '')

export function resolveServiceTypes(modeCodes, formOptionServiceTypes) {
  const options = (formOptionServiceTypes || []).map((o) => (o && typeof o === 'object' ? o.value : o)).filter(Boolean)
  if (!options.length) return modeCodes || [] // form-options not loaded yet → use hint
  const byNorm = new Map(options.map((v) => [normCode(v), v]))
  return (modeCodes || []).map((code) => {
    const hit = byNorm.get(normCode(code))
    if (!hit && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[serviceability] service-type "${code}" not found in form-options — page will show 0. Fix the code in servModes.js.`)
    }
    return hit || code
  })
}
